//Το σχολίασα επειδή το css για το μενού βρίσκεται στο γενικό css το οποίο φωρτονεται στο main.js
//require('navbar.css');
import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/navbar_side.template.htm';
import 'dhtmlxMessage';

export default GenericView.extend({
    el: $("#left-panel"),
    tagName: 'aside',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	userData: null,
	numberPrivilegeLevel: null,
	initialize: function (options) {
		this.userData = options.data;
		//console.info(options.data);
		//console.info(this.userData);
		this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
        this.render();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		this.$el.html(this.template( { privilegeLevel : this.numberPrivilegeLevel } ));

	},
	events:{
	}


});


